import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * SuspenseFallback Component
 * Loading fallback for lazy-loaded components
 */
const SuspenseFallback = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px',
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default SuspenseFallback;
